import { makeStyles } from 'tss-react/mui';

export const useWalletIconStyles = makeStyles()(() => ({
  root: {
    width: '1em',
    height: '1em',
  },
}));
